import { defineComponent as _defineComponent } from 'vue'
import {
  Trade,
  closedTradeStatuses,
  AuthorityType,
  AdminTrade,
  PaymentReport,
  HedgingInstruments,
} from 'ah-api-gateways';
import TradeInfo from 'ah-trades/src/components/info/TradeInfo.vue';
import TradeMarginInfo from 'ah-trades/src/components/info/TradeMarginInfo.vue';
import TradeProfitInfo from 'ah-trades/src/components/info/TradeProfitInfo.vue';
import TradeOnBehalfOfInfo from 'ah-trades/src/components/info/TradeOnBehalfOfInfo.vue';
import DrawdownModal from 'ah-trades/src/components/modals/DrawdownModal.vue';
import ResendTradeConfEmailModal from 'ah-trades/src/components/modals/ResendTradeConfEmailModal.vue';
import CancelTradeModal from 'ah-trades/src/components/modals/CancelTradeModal.vue';
import RollForwardModal from 'ah-trades/src/components/modals/RollForwardModal.vue';
import { TradeStatus } from 'ah-api-gateways';
import TradeDetailsModal from '../info/TradeDetailsModal.vue';
import TradeTransactionDetailsModal from 'ah-wallets/src/components/TradeTransactionDetailsModal.vue';
import { computed, watch, reactive } from 'vue';
import { useTradeState } from '../..';
import { useOnBehalfOf } from 'ah-common-lib/src/onBehalfOf/useInjectedOBO';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeRowDetails',
  props: {
    trade: null,
    readonly: { type: [Boolean, String], default: false }
  },
  emits: ["amend"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'amend', value: Trade | AdminTrade): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { trade: Trade | AdminTrade, readonly: boolean | string };





const isReadonly = computed(() => props.readonly !== false);

const tradeState = useTradeState();

const onBehalfOfClient = useOnBehalfOf();

const requestManager = useRequestManager({
  exposeToParent: true,
}).manager;

const state = reactive<{
  payment: PaymentReport | null;
}>({
  payment: null,
});

const canResendNotifications = computed(() => {
  return onBehalfOfClient.value || tradeState.store.useAuthStore().hasAuthorities(AuthorityType.RESEND_NOTIFICATION);
});

const isAHUser = computed(() => tradeState.store.useAuthStore().isAHUser);

const canRequestPrices = computed(() => {
  return onBehalfOfClient.value || tradeState.store.useAuthStore().hasAuthorities(AuthorityType.REQUEST_PRICES);
});

const tradeIsClosed = computed(() => {
  return closedTradeStatuses.includes(props.trade.status);
});

const isClientUser = computed(() => {
  return tradeState.store.useAuthStore().isClientUser;
});

/**
 * Only Partners/Traders can cancel trades via OBO
 */
const canCancelTrade = computed(() => {
  return (
    tradeState.store.useAuthStore().hasAuthorities(AuthorityType.CANCEL_TRADE) &&
    !!onBehalfOfClient.value &&
    isAHUser.value &&
    props.trade.isCancellable
  );
});

/**
 * Only Partners/Traders can roll forward trades via OBO
 */
const canRollForward = computed(() => {
  return (
    tradeState.store.useAuthStore().hasAuthorities(AuthorityType.ROLLFORWARD_TRADE) &&
    !!onBehalfOfClient.value &&
    isAHUser.value &&
    props.trade.isRollForwardable
  );
});

/**
 * Only Partners/Traders can roll forward trades via OBO
 */
const canAmend = computed(() => {
  return (
    tradeState.store.useAuthStore().hasAuthorities(AuthorityType.AMEND_TRADES) &&
    !!onBehalfOfClient.value &&
    isAHUser.value &&
    props.trade.isAmendable
  );
});

/**
 * Partners/Traders can drawdown via OBO, as can Client users with the correct authority
 */
const drawdownAllowed = computed(() => {
  return (
    (onBehalfOfClient.value || tradeState.store.useAuthStore().hasAuthorities(AuthorityType.DRAWDOWN_TRADE)) &&
    !isReadonly.value
  );
});

const adminTrade = computed(() => props.trade as AdminTrade);

const isVanilla = computed(() => props.trade.hedgingProduct === HedgingInstruments.VANILLA_OPTIONS);

const canViewPayment = computed(() => tradeState.store.useAuthStore().hasAuthorities(AuthorityType.VIEW_PAYMENTS));

function tradeIsAmended(status: TradeStatus) {
  return status === TradeStatus.AMENDED;
}

function amendTrade() {
  emit('amend', props.trade);
}

function loadLinkedPayments() {
  requestManager
    .sameOrCancelAndNew(
      'getLinkedPayments',
      tradeState.services.payments.listPayments({
        tradeId: props.trade.id,
      })
    )
    .subscribe((res) => {
      state.payment = res.list[0];
    });
}

watch(
  () => props.trade,
  () => {
    if (props.trade.referenceNumber) {
      loadLinkedPayments();
    }
  },
  { immediate: true }
);

return { __sfc: true,props, emit, isReadonly, tradeState, onBehalfOfClient, requestManager, state, canResendNotifications, isAHUser, canRequestPrices, tradeIsClosed, isClientUser, canCancelTrade, canRollForward, canAmend, drawdownAllowed, adminTrade, isVanilla, canViewPayment, tradeIsAmended, amendTrade, loadLinkedPayments, TradeInfo, TradeMarginInfo, TradeProfitInfo, TradeOnBehalfOfInfo, DrawdownModal, ResendTradeConfEmailModal, CancelTradeModal, RollForwardModal, TradeDetailsModal, TradeTransactionDetailsModal }
}

})